var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 30,
    viewBox: "0 0 71 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 69,
    height: 28,
    rx: 2,
    stroke: "#CACACA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2506 23.8599H16.3176L12.6185 9.896C12.4429 9.25373 12.0701 8.68582 11.5217 8.41821C10.1531 7.74567 8.64509 7.21033 7 6.94041V6.40277H14.9466C16.0435 6.40277 16.866 7.21033 17.003 8.14829L18.9224 18.2209L23.853 6.40277H28.6488L21.2506 23.8599ZM31.3912 23.8599H26.7324L30.5686 6.40277H35.2274L31.3912 23.8599ZM41.2543 11.2387C41.3915 10.2986 42.214 9.76095 43.1737 9.76095C44.6818 9.62594 46.3244 9.89597 47.6954 10.5662L48.518 6.80755C47.147 6.26991 45.639 6 44.2704 6C39.7487 6 36.4584 8.41806 36.4584 11.7741C36.4584 14.3272 38.789 15.6676 40.4342 16.4752C42.214 17.2804 42.8995 17.8181 42.7624 18.6233C42.7624 19.8312 41.3915 20.3689 40.0229 20.3689C38.3778 20.3689 36.7326 19.9662 35.227 19.2936L34.4044 23.0545C36.0495 23.7248 37.8294 23.9948 39.4745 23.9948C44.5446 24.1274 47.6954 21.7116 47.6954 18.0857C47.6954 13.5195 41.2543 13.2519 41.2543 11.2387ZM64.0003 23.8599L60.3011 6.40277H56.3279C55.5052 6.40277 54.6827 6.94041 54.4085 7.74567L47.5586 23.8599H52.3545L53.3118 21.3092H59.2044L59.7528 23.8599H64.0003ZM57.0126 11.1041L58.3811 17.6833H54.5449L57.0126 11.1041Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.45a0aae1f7261fd03dce160a0d2bcf5d.svg";
export { ForwardRef as ReactComponent };